import { Component, OnInit } from '@angular/core';
import { SiteConfigListenerService } from '../../../services/site-config-listener.service';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { Site, SiteEditorConfig, SiteMataData } from '../../../editor-container/editor-model';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';


@Component({
  selector: 'kve-sites-picker',
  templateUrl: './sites-picker.component.html',
  styleUrls: ['./sites-picker.component.scss']
})
export class SitesPickerComponent implements OnInit {
  sites:SiteMataData[];
  selectedSite:Site;

  colors:string[] = [];

  color = "#FFF";

  themes = [
    {
      id:1,
      value: 'default',
      name: 'Default',
      pallette:'#3366ff',
    },
    {
      id:2,
      value: 'green-house',
      name: 'Green House',
      pallette:"#8CA52E"
    },
    {
      id:3,
      value: 'navy-kadet',
      name: 'Navy Kadet',
      pallette:"#192A53"
    },
    {
      id:4,
      value: 'earthtone',
      name: 'Earth Tone',
      pallette:"#B73225"
    },
    {
      id:5,
      value: 'makeup',
      name: 'Makeup',
      pallette:"#DDAF94"
    },
    {
      id:6,
      value: 'blackish',
      name: 'Blackish',
      pallette:"#202020"
    },
    {
      id:7,
      value: 'cactus',
      name: 'Cactus',
      pallette:"#74AC67"
    },
    {
      id:8,
      value: 'olive-tree',
      name: 'Olive Tree',
      pallette:"#77A19B"
    },
    {
      id:9,
      value: 'citric-acid',
      name: 'Citric Acid',
      pallette:"#FE7C02"
    },
    {
      id:10,
      value: 'wind-swept',
      name: 'Wind Swept',
      pallette:"#AB9390"
    },
    {
      id:11,
      value: 'fools-gold',
      name: 'Fools Gold',
      pallette:"#FFC507"
    },
    {
      id:12,
      value: 'skyroof',
      name: 'Skyroof',
      pallette:"#87CEEB"
    },
    {
      id:13,
      value: 'riding-hood',
      name: 'Ridinghood',
      pallette:"#FF0000"
    },
    {
      id:14,
      value: 'springboks',
      name: 'Sringboks',
      pallette:"#1C8A04"
    },
    {
      id:15,
      value: 'purple-rain',
      name: 'Purple Rain',
      pallette:"#FB03B8"
    },
    {
      id:16,
      value: 'egoli',
      name: 'Egoli',
      pallette:"#FFFF00"
    }
  ];
  selectedSiteSub:Subscription;
  private destroy$ = new Subject<void>();

  constructor(private siteConfigService:SiteConfigListenerService,
    private previewEditStoreService:PreviewEditStoreService,
    private communicator:IframeCommunicationService,
    private ofbizForms:OfbizFormsService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.sites = this.siteConfigService.getSiteMetas();
      if(this.sites.length > 0){
        console.log(this.sites)
        this.sites.forEach(site => {
          let siteTheme = this.themes.find(theme => theme.value == site.themeName);
          if(siteTheme != undefined){
            site.color = siteTheme.pallette;
          }
        })
      }
    }, 1000);
    this.selectedSiteSub = this.previewEditStoreService.selectedSite$
      .pipe(takeUntil(this.destroy$))
      .subscribe((site:Site) => {
      //console.log(site);
      if(site != undefined){
        this.selectedSite = site;
      }
    })
    /* this.ofbizForms.doGetWebSite("website/sites/121234")
      .pipe(take(1))
      .subscribe(sites => {
        this.sites = sites;
        if(this.sites.length > 0){
          this.sites.forEach(site => {
            let siteTheme = this.themes.find(theme => theme.value == site.themeName);
            if(siteTheme != undefined){
              site.color = siteTheme.pallette;
            }
          })
        }
      }) */
    
  }

  selectSite(_site:SiteMataData){
    console.log(_site);
     this.previewEditStoreService.siteEditorSitesState$.subscribe((siteEditorConfig:Site[]) => {
      console.log(siteEditorConfig);
      siteEditorConfig.forEach(site => {
        if(site.siteId == _site.siteId && site.siteId != this.selectedSite){
          this.communicator.sendFromParent({id:"selectedSite",data:site});
          this.previewEditStoreService.updateSelectedSite(site);
          this.previewEditStoreService.updateSelectedSection(null);
          //this.previewEditStoreService.setSelectedSite(site);
        }
      })
     })   
  }
}
